import axios from "axios";
import { api } from "./helper";
const client = axios.create({
  baseURL: api,
  withCredentials: false,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

client.interceptors.request.use((config) => {
  return config;
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

// Forms
function GetFormStyle(formid, uid) {
  const params = {
    id: formid,
    uid: uid,
    action: "style",
  };
  return client.get("forms.php", { params });
}

function GetPublicForm(id) {
  const params = {
    linkid: id,
    action: "publicform",
  };
  return client.get("forms.php", { params });
}

function FormVisit(linkid) {
  var t = {};
  t.action = "visit";
  t.linkid = linkid;
  return client.post("forms.php", t);
}
// Question

function GetPublicQuestions(linkid) {
  const params = {
    linkid: linkid,
    action: "publicquests",
  };
  return client.get("questions.php", { params });
}

// Answer
function GetPublicAnswers(id, linkid) {
  const params = {
    id: id,
    linkid: linkid,
    action: "publicanswers",
  };
  return client.get("answers.php", { params });
}

//Feedback
function Feedback(feedback) {
  return client.post("feedback.php", feedback);
}

export {
  GetPublicForm,
  GetPublicQuestions,
  GetPublicAnswers,
  FormVisit,
  Feedback,
  GetFormStyle,
};
